import axios from 'axios';


export default {
    createProductItem:(data)=>{
        return axios.post('plantilla/guardar/producto',data);
    },
    createProductText:(data)=>{
        return axios.post('plantilla/guardar/texto', data);
    },
    getTextItemData(textId){
        return axios.get('plantilla/detalle/texto/'+textId);
    },
    getProductItemData(productId){
        return axios.get('plantilla/detalle/producto/'+productId);
    },
    updateTextItem:(textId, data)=>{
        return axios.post('plantilla/actualizar/texto/'+textId, data);
    },
    updateProductItem(productId,data){
        return axios.post('plantilla/actualizar/producto/'+productId, data);
    },
    getAllProducts(){
        return axios.get('plantilla/listado/productos');
    },
    getAllTexts(){
        return axios.get('plantilla/listado/textos');
    },
    deleteProduct(idProduct){
        return axios.delete('plantilla/borrar/producto/'+idProduct);
    },
    deleteText(idText){
        return axios.delete('plantilla/borrar/texto/'+idText);
    },
    createTemplateQuote(data){
        return axios.post('plantilla/guardar/cotizacion', data);
    },
    updateTemplateQuote(idTemplateQuote,data){
        return axios.post('plantilla/actualizar/cotizacion/'+idTemplateQuote, data);
    },

    addItemsTemplateQuote(templateUuid, data) {
        data.append('_method', 'PUT');
        return axios.post(`plantilla/${templateUuid}/items`, data);
    },

    getQuoteTemplateDetails(idQuoteTemplate) {
        return axios.get(`plantilla/${idQuoteTemplate}`);
    },

    duplicateTemplateProduct(idTemplateProduct){
        return axios.get('plantilla/duplicar/producto/'+idTemplateProduct);
    },
    templateProductBulkActions(data){
        return axios.post('plantilla/acciones/lotes/productos', data);
    },
    templateTextsBulkActions(data){
        return axios.post('plantilla/acciones/lotes/textos', data);
    },
    duplicateText(idText){
        return axios.get('plantilla/duplicar/texto/'+idText);
    }

}
